import { ProviderType } from 'src/modules/user/models/user';

type ProviderOrType = { providerType?: string | null } | ProviderType | undefined;
type Config<T> = { [key in ProviderType]?: T };

export function getConfigForProviderType<T = string>(
    providerOrType: ProviderOrType,
    config: Config<T>,
): T | undefined;

export function getConfigForProviderType<T = string>(
    providerOrType: ProviderOrType,
    config: Config<T>,
    defVal: T,
): T;

export function getConfigForProviderType<T = string>(
    providerOrType: ProviderOrType,
    config: Config<T>,
    defVal?: T,
) {
    const providerType =
        typeof providerOrType === 'object' ? providerOrType.providerType : providerOrType;

    if (!providerType) {
        return defVal;
    }

    return config[providerType] !== undefined ? config[providerType] : defVal;
}
